<ion-header no-border>
    <ion-toolbar class="ion-text-center">
        <ion-buttons slot="start">
            <ion-button (click)="introModal()">
                <ion-icon name="help-circle-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Learn about our Project!</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismissModal()">
                <ion-icon name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
    <div class="about-content">
        <ion-card>
            <ion-item (click)="scrollTo('brainstorm')">
                <ion-icon name="people-outline" slot="start"></ion-icon>
                <ion-label>Gruppenfindung & Brainstorming</ion-label>
            </ion-item>

            <ion-item (click)="scrollTo('planung')">
                <ion-icon name="document-text-outline" slot="start"></ion-icon>
                <ion-label>Die Planung beginnt</ion-label>
            </ion-item>

            <ion-item (click)="scrollTo('umsetzung')">
                <ion-icon name="code-working-outline" slot="start"></ion-icon>
                <ion-label>Umsetzung</ion-label>
            </ion-item>

            <ion-item (click)="scrollTo('conclusion')">
                <ion-icon name="document-lock-outline" slot="start"></ion-icon>
                <ion-label>Conclusion</ion-label>
            </ion-item>
        </ion-card>

        <ion-card id="brainstorm">
            <ion-item>
                <ion-icon name="document-text-outline" slot="start"></ion-icon>
                <ion-label>Gruppenfindung & Brainstorming</ion-label>
            </ion-item>

            <ion-card-content>
                <p>Die Gruppenbildung wurde auf Basis unserer Selbsteinschätzung getätigt. Auf einem Miro wurden von
                    jedem Studenten die Fähigkeiten notiert, die</p>
                <ul>
                    <li>wir beherrschen</li>
                    <li>wir beherrschen wollen</li>
                    <li>wir nicht beherrschen</li>
                </ul>
                <p>So konnten sehr einfach gut zusammenpassende Teams entstehen.</p>
                <p>Nachdem wir (Andi, Benni, Jasmin, Max und Kristof) uns zusammengefunden haben, wurde zu Beginn eine
                    aus dem Design-Thinking gelernte Brainstorming-Methode angewandt um so viele Ideen als Möglich zu
                    finden. Das Ziel war es, einen gemeinsamen "Golden Nugget" zu finden. Wir wollten nicht einfach
                    etwas umsetzen, um das Projekt schnell zu beenden. Uns ging es darum, mit einer persönlichen
                    Motivation an diese Arbeit heranzugehen.</p>
                <img src="../assets/imgs/about/andi_brainstorm.png"/>
                <img src="../assets/imgs/about/max_brainstorm.png"/>
                <img src="../assets/imgs/about/kristof_brainstorm.png"/>
                <p>Nach einer Brainstorm-Session auf dem Miro-Board haben wir uns gegenseitig die Ideen vorgestellt.</p>
                <p>Beim Vorstellen waren wir alle sofort von Andreas Gamification-Ansatz angetan. Schnell hat sich eine
                    Synergie um diese Idee entwickelt und eine zweite spontane Brainstorming-Session, diesmal in der
                    Gruppe, ist entfacht. </p>
                <img src="../assets/imgs/about/spark.png"/>
                <p>Daraus hat sich dieser "spark" wie wir ihn nennen herauskristalisiert. Damit waren wir alle sehr
                    zufrieden und wir sind in die Planungsphase gegangen.</p>
            </ion-card-content>
        </ion-card>

        <ion-card id="planung">
            <ion-item>
                <ion-icon name="people-outline" slot="start"></ion-icon>
                <ion-label>Konkrete Planungsphase</ion-label>
            </ion-item>

            <ion-card-content>
                <p>In der Planungsphase haben wir unseren Spark explizit nochmal auf die Aufgabenstellung bezogen und
                    sind von hier aus mit ihm auf eine Reise der Ideenfindung und Orientierung bis hin zum Golden
                    Nugget/App-Plan gegangen</p>
                <img src="../assets/imgs/about/bs2.png"/>
                <img src="../assets/imgs/about/bs3.png"/>
                <img src="../assets/imgs/about/bs4.png"/>
                <p>Im Endeffekt haben wir die Gamification-Idee zusammen mit einem Community-Aspekt geplant. Die Pflanze
                    wird als Spielfigur am Tamagotchi angelehnt und immer von 2 Studenten betreut. Unsere Pflanzen
                    nennen wir Batamis. Um den Community-Aspekt noch zu intensivieren, wurde eine Forest-Ansicht
                    geplant, die alle Pflanzen der anderen 2er Teams zeigt.</p>
                <p>Gepaart mit unserer Vorstellung, dass die Pflanzen in gewisser Weise den mentalen Zustand der
                    Betreuer reflektieren, können wir mit dieser Ansicht so eine Gruppendynamik entwickeln, die unsere
                    CoCommunity aufmerksam aufeinander macht.</p>
                <br>
                <p>Somit hatten wir auch unser Golden Nugget herausgearbeitet:<br><b>Wir wollen CoCo helfen, ein Gefühl
                    dafür zu entwickeln, wie es den Studenten geht, indem wir die Gesundheit der Partnerpflanzen
                    verfolgen.</b></p>
            </ion-card-content>
        </ion-card>

        <ion-card id="umsetzung">
            <ion-item>
                <ion-icon name="code-working-outline" slot="start"></ion-icon>
                <ion-label>Umsetzung</ion-label>
            </ion-item>

            <ion-card-content>
                <p>Nun, da wir alles durchgeplant hatten, ging es an die Umsetzung. Zu Beginn haben wir unser Team in
                    ein Design-Team und ein Code-Team aufgeteilt. Im Code-Team haben wir mit einem Fork einer Angular
                    Ionic App begonnen, die auf einem alten Projekt von Max beruht. Im Design-Team wurde es kreativ und
                    die Batami-Charaktere sowie unsere Forest-View entstand.</p>
                <img src="../assets/imgs/about/growcoco.png"/>
                <img src="../assets/imgs/about/design1.png"/>
                <img src="../assets/imgs/about/design2.png"/>
                <img src="../assets/imgs/about/design3.jpg"/>
                <img src="../assets/imgs/about/design4.jpg"/>
                <p>Im Coding-Team arbeiteten wir mit Feature-Branches. Für jedes Feature wurde also ein neuer Branch
                    angelegt, der nachher in den master Branch gemerged wurde.</p>
                <p>Begonnen wurde mit dem Data Service für die Live-Daten des Mikrocontrollers. Dieser zieht live unsere
                    Mikrocontroller Daten von dem bereitgestellten WebSocket und macht Sie in unserer Applikation
                    verwendbar</p>
                <p>Anschließend musste p5 eingebunden und das Canvas für das Zeichnen unserer Batami-Objects eingebaut
                    werden. Besonders schwierig bei diesem Schritt war es, das p5-Canvas responsive einzubinden.</p>
                <p>Nachdem das erledigt wurde, konnten wir uns auf die Models "Batami" und "Forest" konzentrieren, die
                    unsere Batamis mit den Live-Daten verbindet und auf dem Canvas zeichnet.</p>
                <p>Währenddessen entschied sich das Design-Team für 3D-Objects und gegen normale Grafiken für die
                    Batamis. Das stellte Code-technisch zu Beginn keine allzu große Hürde dar, denn p5 bringt Funktionen
                    dazu mit.</p>
                <p>Um das ganze noch etwas lebendiger aussehen zu lassen, wurden ein move-Feature für die Batamis
                    eingebaut. Hierzu musste dann auch eine collision-Überprüfung stattfinden.</p>

            </ion-card-content>
        </ion-card>

        <ion-card id="conclusion">
            <ion-item>
                <ion-icon name="document-lock-outline" slot="start"></ion-icon>
                <ion-label>Conclusion</ion-label>
            </ion-item>

            <ion-card-content>
            </ion-card-content>
        </ion-card>

    </div>
</ion-content>
<!--

-->
